<a id="csv-donwload"></a>

<div class="mb-3 flex align-items-center gap-2">
  <button
    pButton
    type="button"
    (click)="navigateToRegister()"
    class="p-button-success"
    pTooltip="ASIN手動登録"
    tooltipPosition="bottom">
    <i
      class="pi pi-plus"
      aria-hidden="true"></i>
    新規登録
  </button>
  <button
    pButton
    type="button"
    (click)="navigateToList()"
    class="p-button-info"
    pTooltip="Amazon通知一覧"
    tooltipPosition="bottom">
    <i
      class="pi pi-list"
      aria-hidden="true"></i>
    個別登録一覧
  </button>
  <button
    pButton
    type="button"
    (click)="deleteSelected()"
    class="p-button-danger"
    [disabled]="selectedProducts.length === 0"
    pTooltip="選択した項目を一括削除"
    tooltipPosition="bottom">
    <i
      class="pi pi-trash"
      aria-hidden="true"></i>
    選択削除 ({{ selectedProducts.length }}件)
  </button>
</div>

<p-panel
  header="検索"
  [toggleable]="true"
  [collapsed]="false">
  <div class="grid">
    <div class="col-3">
      <label for="ms-groupedArea">通知日での絞り込み</label>
      <div class="card justify-content-center p-label">
        <p-select
          [options]="dateOpts"
          [(ngModel)]="filterDate"
          (onChange)="onChangeFilterSelect($event)"
          placeholder="絞り込みの日付を選択"
          display="chip"></p-select>
      </div>
    </div>
    <div class="col-3">
      <label for="ms-groupedArea">通知項目での絞り込み</label>
      <div class="card justify-content-center p-label">
        <p-multiselect
          [options]="noticeOpts"
          [(ngModel)]="filterNotice"
          (onChange)="onChangeFilterSelect($event)"
          placeholder="絞り込みの通知項目を選択"
          display="chip"></p-multiselect>
      </div>
    </div>
  </div>
</p-panel>
<div class="table-header-sticky-outer">
  全{{ products.length.toLocaleString() }}件
  <p-table
    #mainTable
    [value]="products"
    [(selection)]="selectedProducts"
    [loading]="loading"
    columnResizeMode="expand"
    tableStyleClass="p-datatable-responsive"
    class="table-header-sticky p-datatable-responsive"
    [paginator]="true"
    [rows]="50"
    [rowsPerPageOptions]="[100, 250, 500]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{totalRecords} 件中 {first} 〜 {last}"
    paginatorPosition="both"
    dataKey="amazonProduct.asin"
    [globalFilterFields]="['product.jan', 'amazonProduct.name', 'amazonProduct.asin']">
    <ng-template #caption>
      <div class="table-caption">
        <div class="grid">
          <div class="col-3">
            <div class="p-d-flex">
              <button
                type="button"
                pButton
                iconOnly
                pRipple
                (click)="downloadCsv(mainTable)"
                class="p-mr-2"
                pTooltip="CSV"
                tooltipPosition="bottom">
                <i
                  class="pi pi-download"
                  aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="col-5"></div>
          <div class="col-3">
            <span class="p-input-icon-left ml-auto input-full">
              <i class="pi pi-search"></i>
              <input
                pInputText
                class="input-full"
                type="text"
                (input)="mainTable.filterGlobal($event.target.value, 'contains')"
                placeholder="検索キーワード" />
            </span>
          </div>
          <div class="col-1">
            <button
              pButton
              class="p-button-outlined"
              (click)="mainTable.clear()">
              <i
                class="pi pi-filter-slash"
                aria-hidden="true"></i>
              Clear
            </button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th width="3%">
          <p-tableheadercheckbox></p-tableheadercheckbox>
        </th>
        <th width="4%">画像</th>
        <th width="8%">Keepaグラフ</th>
        <th
          width="6%"
          pSortableColumn="asin">
          ASIN
          <p-sorticon field="asin"></p-sorticon>
        </th>
        <th width="5%">JAN</th>
        <th width="17%">商品名</th>
        <th
          width="4%"
          pSortableColumn="topCategory">
          カテゴリ
          <p-sorticon field="buyingPrice"></p-sorticon>
        </th>
        <th width="7%">登録者</th>
        <th width="12%">メモ</th>
        <th width="15%">通知内容</th>
        <th width="6%">操作</th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-product>
      <tr>
        <td>
          <p-tablecheckbox [value]="product"></p-tablecheckbox>
        </td>
        <td>
          <a
            href="https://keepa.com/#!product/5-{{ product.amazonProduct.asin }}"
            target="_blank">
            <img
              src="{{ product.amazonProduct.imageUrl }}"
              style="width: 50px" />
          </a>
        </td>
        <td>
          <app-keepa-graph [asin]="product.amazonProduct.asin"></app-keepa-graph>
        </td>
        <td>
          <a
            href="https://www.amazon.co.jp/dp/{{ product.amazonProduct.asin }}"
            target="_blank">
            {{ product.amazonProduct.asin }}
          </a>
        </td>
        <td>
          {{ product.product.jan }}
          @if (product.amazonProduct.keepaProduct?.boughtPastMonth != null) {
            <br />
            前月販売:
            {{
              product.amazonProduct.keepaProduct.boughtPastMonth < 10
                ? '9以下'
                : product.amazonProduct.keepaProduct.boughtPastMonth
            }}
          }
        </td>
        <td>
          {{ product.amazonProduct.name }}
        </td>
        <td>{{ product.amazonProduct.topCategory }}</td>
        <td>
          @if (product.userAmazonNotification?.user?.name) {
            <div>
              {{ product.userAmazonNotification.user.name }}
              <br />
              <small>{{ formatDate(product.userAmazonNotification.createdAt) }}</small>
            </div>
          } @else {
            -
          }
        </td>
        <td>
          <div class="flex align-items-center gap-2">
            <div
              class="text-overflow-ellipsis flex-1"
              [title]="$safeNavigationMigration(product.userAmazonNotification?.memo)">
              {{ product.userAmazonNotification?.memo || '-' }}
            </div>
            <i
              class="pi pi-user-edit clickable"
              style="font-size: 1rem; cursor: pointer; color: #007ad9"
              (click)="openMemoDialog(product)"
              pTooltip="メモを編集"
              tooltipPosition="top"></i>
          </div>
        </td>
        <td><app-badges [notices]="product.amazonNotifications"></app-badges></td>
        <td>
          <i
            class="pi pi-trash clickable"
            style="font-size: 1rem; cursor: pointer; color: #dc3545"
            (click)="deleteProduct(product)"
            pTooltip="削除"
            tooltipPosition="top"></i>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td
          colspan="11"
          class="text-center">
          データがありません
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- メモ編集モーダル -->
<p-dialog
  header="メモを編集"
  [(visible)]="showMemoDialog"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false">
  @if (currentProduct) {
    <div class="grid">
      <div class="col-12 mb-3">
        <div class="flex align-items-center gap-2">
          <img
            [src]="currentProduct.amazonProduct.imageUrl"
            style="width: 40px; height: auto"
            alt="商品画像" />
          <div>
            <div class="font-semibold">{{ currentProduct.amazonProduct.name }}</div>
            <div class="text-sm text-gray-600">ASIN: {{ currentProduct.amazonProduct.asin }}</div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <label for="memoTextarea">メモ</label>
        <textarea
          id="memoTextarea"
          rows="4"
          class="p-inputtext w-full"
          pTextarea
          [(ngModel)]="memoText"
          placeholder="メモを入力してください"></textarea>
      </div>
      <div class="col-12 flex justify-content-end gap-2 mt-3">
        <button
          pButton
          type="button"
          class="p-button-outlined"
          (click)="closeMemoDialog()">
          キャンセル
        </button>
        <button
          pButton
          type="button"
          (click)="saveMemo()">
          保存
        </button>
      </div>
    </div>
  }
</p-dialog>
